import MicroModal from 'micromodal';

export default () => ({
	isReadMoreVisible: false,
	isSizingGuideAvailable: document.querySelector('#sizing-guide-modal'),
	init() {
		this.readMore();

		MicroModal.init();
	},
	showModal() {
		MicroModal.show('sizing-guide-modal');
	},
	readMore() {
		const mql = window.matchMedia('screen and (max-width: 768px)');

		setTimeout(() => {
			if (
				this.$refs.heightDefiner.offsetHeight > this.$refs.col1.offsetHeight &&
				this.$refs.col1.offsetHeight > 0 &&
				!mql.matches
			) {
				this.isReadMoreVisible = true;

				this.$refs.col2.style.height = `${this.$refs.col1.offsetHeight}px`;
			}
		}, 10);
	},
	removeReadMore() {
		this.isReadMoreVisible = false;
		this.$refs.col2.style.height = `${this.$refs.heightDefiner.offsetHeight}px`;

		setTimeout(() => {
			this.$refs.col2.style.height = null;
		}, 5000);
	},
});
